import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Message } from '../message';
import { MessagesService } from '../messages.service';
import { ListComponent, PopUpService, StoreService } from 'app/core';

@Component({
  selector: 'lms-messages-list',
  templateUrl: './messages-list.component.html',
  styleUrls: ['./messages-list.component.scss']
})
export class MessagesListComponent implements OnChanges {
  @Input() listId: string;
  @Input() options: any;
  public group: any;
  public groupMessagesListId = 'MARS_GROUP_MESSAGES_LIST';
  @Output() listUpdated: EventEmitter<any> = new EventEmitter<any>();
  public defaultOptions: any = { sort: '-created_at', elementsName: 'groupMessages.label' };
  public listOptions: any;
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  messages: Message[];

  constructor(
    public messagesService: MessagesService,
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnChanges() {
    this.route.data.subscribe((data) => {
      this.group = data['group'];
    });
    this.listOptions = Object.assign({}, this.defaultOptions, this.options);
    this.listOptions.filters = new Map<string, string>(this.listOptions.filters);
    this.listOptions.filters.set('type', 'RRHH_MESSAGE');
  }
  onMessageCreated(message) {
    StoreService.merge(this.listId, { active: true });
  }
  setCollection(collection) {
    this.messages = collection;
    this.listUpdated.emit(collection);
  }
}
